import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Full-screen overlay shown when the user's session has expired.
 * Replaces the infinite spinner that previously appeared when token
 * refresh failed after an overnight session.
 */
export function SessionExpiredOverlay() {
  const { clearSessionExpired } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = () => {
    clearSessionExpired();
    navigate('/login', { state: { from: location }, replace: true });
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
    >
      <Card
        sx={{
          maxWidth: 400,
          width: '90%',
          textAlign: 'center',
          p: 2,
        }}
      >
        <CardContent>
          <LockOutlinedIcon
            sx={{ fontSize: 56, color: 'text.secondary', mb: 2 }}
            aria-hidden="true"
          />
          <Typography
            id="session-expired-title"
            variant="h5"
            fontWeight={600}
            gutterBottom
          >
            Session Expired
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            You were away for a while and your session has ended. Please log in again to continue.
          </Typography>
          <Button variant="contained" size="large" fullWidth onClick={handleLogin}>
            Log In
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
